export default {"src":"/_next/static/media/burger-menu-v2.cdc2ed9f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};